import { useEffect, useState } from "react";
import { getAllDocumentsApi } from "../../app/api";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io/";

export default function AllDocuments() {


  const [search, setSearch] = useState("");



  const [groupedDocs, setGroupedDocs] = useState({});
  const [openUser, setOpenUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadDocuments();
  }, []);


  const filteredUsers = Object.keys(groupedDocs)
    .filter((userName) =>
      userName.toLowerCase().includes(search.toLowerCase())
    )
    .sort((a, b) => a.localeCompare(b)); // ✅ alphabetical

  const loadDocuments = async () => {
    try {
      setLoading(true);

      const res = await getAllDocumentsApi();

      if (res?.success && Array.isArray(res?.data)) {

        const grouped = {};

        res.data.forEach((doc) => {

          const name = doc.user_name || "Unknown User";

          if (!grouped[name]) {
            grouped[name] = [];
          }

          grouped[name].push(doc);
        });

        setGroupedDocs(grouped);
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 5;


  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);


  useEffect(() => {
    setCurrentPage(1);
  }, [search]);
  //   return (
  //     <div className="p-6 md:mt-20 text-white max-w-6xl mx-auto">

  //       <div className="bg-[#1e1147] p-6 rounded-2xl shadow-lg">

  //         {/* <h2 className="text-2xl font-semibold mb-6">
  //           All Documents
  //         </h2> */}



  // <div className="flex justify-between items-center mb-6">
  //   <h2 className="text-2xl font-semibold">
  //     All Documents
  //   </h2>

  //   <input
  //     type="text"
  //     placeholder="Search employee..."
  //     value={search}
  //     onChange={(e) => setSearch(e.target.value)}
  //     className="px-3 py-2 rounded bg-white/10 border border-white/20 text-white placeholder:text-white/60 outline-none"
  //   />
  // </div>

  //         {loading && (
  //           <p className="text-gray-400">Loading...</p>
  //         )}

  //         {!loading && Object.keys(groupedDocs).length === 0 && (
  //           <p className="text-gray-400">No documents found</p>
  //         )}

  //         {/* {Object.keys(groupedDocs).map((userName) => ( */}
  //           {filteredUsers.map((userName) => (


  //           <div key={userName} className="mb-4">

  //             {/* USER FOLDER */}
  //             <div
  //               onClick={() =>
  //                 setOpenUser(openUser === userName ? null : userName)
  //               }
  //               className="cursor-pointer bg-white/10 hover:bg-white/20 transition p-3 rounded-lg flex justify-between items-center"
  //             >
  //               <span className="font-semibold">
  //                 📁 {userName}
  //               </span>

  //               <span>{openUser === userName ? "▲" : "▼"}</span>
  //             </div>

  //             {/* DOCUMENTS */}
  //             {openUser === userName && (
  //               <div className="ml-6 mt-2 space-y-2">

  //                 {groupedDocs[userName].map((doc) => (

  //                   <div
  //                     key={doc.id}
  //                     className="flex justify-between items-center bg-white/5 hover:bg-white/10 transition p-2 rounded"
  //                   >
  //                     <span className="text-sm">
  //                       📄 {doc.document_type}
  //                     </span>

  //                     <a

  // // href={`${FILE_BASE_URL}${exp.bill_path}`}
  //                       href={`${IMAGE_BASE_URL}${doc.file_path}`}
  //                       target="_blank"
  //                       rel="noreferrer"
  //                       className="text-blue-400 hover:underline"
  //                     >
  //                       View
  //                     </a>

  //                   </div>

  //                 ))}

  //               </div>
  //             )}

  //           </div>

  //         ))}

  //       </div>

  //     </div>
  //   );






  return (
    <div className=" md:mt-20 text-white max-w-6xl mx-auto">

      <div className="
      bg-gradient-to-br from-[#1e1447] via-[#1a1240] to-[#0f0a2c]
      p-6 rounded-[24px]
      border border-white/10
      shadow-[0_20px_60px_rgba(0,0,0,0.6)]
    ">

        {/* HEADER */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          <h2 className="text-2xl font-semibold tracking-wide">
            📂 All Documents
          </h2>

          <input
            type="text"
            placeholder="Search employee..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="
            w-full md:w-[280px]
            px-4 py-2 rounded-xl
            bg-white/10 border border-white/20
            text-white placeholder:text-white/60
            outline-none
            focus:border-cyan-400
            transition
          "
          />
        </div>

        {/* STATES */}
        {loading && (
          <p className="text-gray-400">Loading...</p>
        )}

        {!loading && Object.keys(groupedDocs).length === 0 && (
          <p className="text-gray-400">No documents found</p>
        )}

        {/* USERS LIST */}
        <div className="space-y-5">

          {currentUsers.map((userName) => {

            const isOpen = openUser === userName;
            const docs = groupedDocs[userName];

            return (
              <div
                key={userName}
                className="
                rounded-2xl
                border border-white/10
                bg-white/[0.04]
                overflow-hidden
                transition-all
              "
              >

                {/* USER HEADER */}
                <div
                  onClick={() =>
                    setOpenUser(isOpen ? null : userName)
                  }
                  className="
                  flex items-center justify-between
                  px-5 py-4
                  cursor-pointer
                  hover:bg-white/10
                  transition
                "
                >
                  {/* LEFT */}
                  <div className="flex items-center gap-4">

                    {/* Avatar */}
                    <div className="
                    w-10 h-10 rounded-full
                    bg-gradient-to-r from-purple-500 to-pink-500
                    flex items-center justify-center
                    font-semibold
                  ">
                      {userName.charAt(0).toUpperCase()}
                    </div>

                    {/* Name + Count */}
                    <div>
                      <p className="font-medium text-white">
                        {userName}
                      </p>
                      <p className="text-xs text-gray-400">
                        {docs.length} document{docs.length > 1 ? "s" : ""}
                      </p>
                    </div>
                  </div>

                  {/* RIGHT */}
                  <div className="text-gray-300 text-sm">
                    {isOpen ? "▲" : "▼"}
                  </div>
                </div>

                {/* DOCUMENTS */}
                {isOpen && (
                  <div className="
                  border-t border-white/10
                  px-5 py-4
                  bg-white/[0.03]
                  space-y-3
                ">

                    {docs.map((doc) => (
                      <div
                        key={doc.id}
                        className="
                        flex items-center justify-between
                        px-4 py-3
                        rounded-xl
                        bg-white/5
                        border border-white/10
                        hover:bg-white/10
                        transition
                      "
                      >
                        {/* LEFT */}
                        <div className="flex items-center gap-3">
                          <span className="text-lg">📄</span>
                          <span className="text-sm text-gray-200">
                            {doc.document_type}
                          </span>
                        </div>

                        {/* RIGHT */}
                        <a
                          href={`${IMAGE_BASE_URL}${doc.file_path}`}
                          target="_blank"
                          rel="noreferrer"
                          className="
                          text-sm
                          px-3 py-1
                          rounded-lg
                          bg-cyan-500/20
                          text-cyan-300
                          hover:bg-cyan-500/30
                          transition
                        "
                        >
                          View
                        </a>
                      </div>
                    ))}

                  </div>
                )}

              </div>
            );
          })}

        </div>

        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-2 mt-10 flex-wrap">

            {/* PREV BUTTON */}
            <button
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
              disabled={currentPage === 1}
              className="
        px-4 py-2 rounded-xl text-sm
        bg-white/10 backdrop-blur-md
        border border-white/20
        hover:bg-white/20
        transition-all duration-200
        disabled:opacity-40 disabled:cursor-not-allowed
      "
            >
              ←
            </button>

            {/* PAGE NUMBERS */}
            {/* {[...Array(totalPages)].map((_, index) => {
      const page = index + 1;
      const isActive = page === currentPage;

      return (
        <button
          key={page}
          onClick={() => setCurrentPage(page)}
          className={`
            px-3 py-1.5 text-sm rounded-lg
            transition-all duration-200
            border
            ${
              isActive
                ? "bg-gradient-to-r from-cyan-500 to-blue-500 text-white border-transparent shadow-lg scale-105"
                : "bg-white/10 text-white border-white/20 hover:bg-white/20"
            }
          `}
        >
          {page}
        </button>
      );
    })} */}



            {(() => {
              const pages = [];

              const addPage = (p) => {
                pages.push(
                  <button
                    key={p}
                    onClick={() => setCurrentPage(p)}
                    className={`
          px-3 py-1.5 text-sm rounded-lg border transition
          ${currentPage === p
                        ? "bg-gradient-to-r from-cyan-500 to-blue-500 text-white border-transparent scale-105"
                        : "bg-white/10 text-white border-white/20 hover:bg-white/20"
                      }
        `}
                  >
                    {p}
                  </button>
                );
              };

              const addDots = (key) => (
                <span key={key} className="px-2 text-white/50">
                  ...
                </span>
              );

              if (totalPages <= 7) {
                // small pages → show all
                for (let i = 1; i <= totalPages; i++) addPage(i);
              } else {
                // always show first
                addPage(1);

                if (currentPage > 4) addDots("start");

                const start = Math.max(2, currentPage - 1);
                const end = Math.min(totalPages - 1, currentPage + 1);

                for (let i = start; i <= end; i++) {
                  addPage(i);
                }

                if (currentPage < totalPages - 3) addDots("end");

                // always show last
                addPage(totalPages);
              }

              return pages;
            })()}

            {/* NEXT BUTTON */}
            <button
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
              disabled={currentPage === totalPages}
              className="
        px-4 py-2 rounded-xl text-sm
        bg-white/10 backdrop-blur-md
        border border-white/20
        hover:bg-white/20
        transition-all duration-200
        disabled:opacity-40 disabled:cursor-not-allowed
      "
            >
              →
            </button>

          </div>
        )}


      </div>







    </div>
  );




}